// extracted by mini-css-extract-plugin
export default {"ganttVerticalContainer":"gantt_ganttVerticalContainer__SI2tc","horizontalContainer":"gantt_horizontalContainer__PTcLo","wrapper":"gantt_wrapper__fUmxQ"};